import { useEffect } from 'react';

const LOCK_COUNT_KEY = 'bodyScrollLockCount';
const SCROLL_Y_KEY = 'bodyScrollLockScrollY';
const ORIGINAL_OVERFLOW_KEY = 'bodyScrollLockOriginalOverflow';
const ORIGINAL_POSITION_KEY = 'bodyScrollLockOriginalPosition';
const ORIGINAL_TOP_KEY = 'bodyScrollLockOriginalTop';
const ORIGINAL_WIDTH_KEY = 'bodyScrollLockOriginalWidth';
const ORIGINAL_PADDING_RIGHT_KEY = 'bodyScrollLockOriginalPaddingRight';

const getLockCount = (body) => Number(body.dataset[LOCK_COUNT_KEY] || 0);

export const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (!isLocked || typeof window === 'undefined') {
      return undefined;
    }

    const { body, documentElement } = document;
    const currentLockCount = getLockCount(body);

    if (currentLockCount === 0) {
      const scrollY = window.scrollY;
      const scrollbarWidth = window.innerWidth - documentElement.clientWidth;

      body.dataset[SCROLL_Y_KEY] = String(scrollY);
      body.dataset[ORIGINAL_OVERFLOW_KEY] = body.style.overflow;
      body.dataset[ORIGINAL_POSITION_KEY] = body.style.position;
      body.dataset[ORIGINAL_TOP_KEY] = body.style.top;
      body.dataset[ORIGINAL_WIDTH_KEY] = body.style.width;
      body.dataset[ORIGINAL_PADDING_RIGHT_KEY] = body.style.paddingRight;

      body.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.width = '100%';

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    body.dataset[LOCK_COUNT_KEY] = String(currentLockCount + 1);

    return () => {
      const nextLockCount = Math.max(getLockCount(body) - 1, 0);

      if (nextLockCount === 0) {
        const scrollY = Number(body.dataset[SCROLL_Y_KEY] || 0);

        body.style.overflow = body.dataset[ORIGINAL_OVERFLOW_KEY] || '';
        body.style.position = body.dataset[ORIGINAL_POSITION_KEY] || '';
        body.style.top = body.dataset[ORIGINAL_TOP_KEY] || '';
        body.style.width = body.dataset[ORIGINAL_WIDTH_KEY] || '';
        body.style.paddingRight = body.dataset[ORIGINAL_PADDING_RIGHT_KEY] || '';

        delete body.dataset[LOCK_COUNT_KEY];
        delete body.dataset[SCROLL_Y_KEY];
        delete body.dataset[ORIGINAL_OVERFLOW_KEY];
        delete body.dataset[ORIGINAL_POSITION_KEY];
        delete body.dataset[ORIGINAL_TOP_KEY];
        delete body.dataset[ORIGINAL_WIDTH_KEY];
        delete body.dataset[ORIGINAL_PADDING_RIGHT_KEY];

        window.scrollTo(0, scrollY);
        return;
      }

      body.dataset[LOCK_COUNT_KEY] = String(nextLockCount);
    };
  }, [isLocked]);
};

export default useBodyScrollLock;
